import { createSlice } from "@reduxjs/toolkit";

export const vrlTraining = createSlice({
	name: "vrl",
	initialState: {
		proyects: [],
		responses: [],
		averageResponses: 0,
		groups: [],
		proyectSelected: {},
	},
	reducers: {
		addPryectsTraining: (state, { payload }) => {
			state.proyects = payload;
		},
		addResponsesTraining: (state, { payload }) => {
			state.responses = payload;
		},
		setProyectSelectedTraining: (state, { payload }) => {
			state.proyectSelected = payload;
		},
		setGroupsTraining: (state, { payload }) => {
			state.groups = payload.groups;
			console.log("grupos de proyecto seleccionado", state.groups);
		},
		// setAverageResponses: (state, { payload }) => {
		// 	state.averageResponses = payload;
		// },
	},
});

export const { addPryectsTraining, addResponsesTraining, setProyectSelectedTraining, setGroupsTraining } = vrlTraining.actions;
